import { makeFetchAction } from 'redux-api-call';
import { EMARKET_ADMIN_API } from 'utils/envConfig';

const COMPLETE_ORDER_API_ID = 'ECOM_COMPLETE_ORDER';

const {
  actionCreator: completeOrderAC,
  dataSelector: completeOrderDataSelector,
  errorSelector: completeOrderErrorSelector,
  isFetchingSelector: isSubmittingOrderSelector,
} = makeFetchAction(COMPLETE_ORDER_API_ID, id => ({
  endpoint: `${EMARKET_ADMIN_API}/ecomorders/${id}`,
  method: 'PUT',
  notify: true,
  body: { status: 1001, payment_status: 1001 },
}));

export {
  COMPLETE_ORDER_API_ID,
  completeOrderAC,
  completeOrderDataSelector,
  completeOrderErrorSelector,
  isSubmittingOrderSelector,
};
